// Redeployment Center's two directions over the same employee/JD data —
// "role" starts from a role and lists candidate people, "job" (Employee
// View) starts from a person and lists candidate roles.
export const REDEPLOYMENT_VIEW_MODE = Object.freeze({
  ROLE: "role",
  EMPLOYEE: "job",
});

export const REDEPLOYMENT_VIEW_OPTIONS = [
  { label: "Role View", value: REDEPLOYMENT_VIEW_MODE.ROLE },
  { label: "Employee View", value: REDEPLOYMENT_VIEW_MODE.EMPLOYEE },
];

// One-line explainer under the page title, per view.
export const REDEPLOYMENT_VIEW_DESCRIPTION = Object.freeze({
  [REDEPLOYMENT_VIEW_MODE.ROLE]:
    "Lower a role's Target Positions below its Current Positions to plan a reduction — click the row to see who's affected.",
  [REDEPLOYMENT_VIEW_MODE.EMPLOYEE]:
    "Start from a person already in a role and see which other roles they could play, ranked by SMI.",
});

export const REDUCTION_SUMMARY_CSV_FILENAME = "redeployment-analysis-summary";
